import axios from '@/library/modules/axios.js'
// 发送验证码
export function sendCode(params, phone_number) {
  return axios.service({
    url: `/apis/v1/user/customer-api/users/user-phone-number/${phone_number}/send-message`,
    method: 'get',
    params
  })
}
// jwt解秘
export function getUserInfo(params) {
  return axios.service({
    url: `/apis/v1/user/session/decode`,
    method: 'get',
    params
  })
} // 用户登录
export function login(data) {
  return axios.service({
    url: `/apis/v1/user/session/users`,
    method: 'post',
    data
  })
}
// 用户更换手机
export function changePhone(data) {
  return axios.service({
    url: `/apis/v1/user/customer-api/users/update-phone-number`,
    method: 'put',
    data
  })
}
// 用户绑定手机
export function bindPhone(data) {
  return axios.service({
    url: `/apis/v1/user/customer-api/users/binding-phone-number`,
    method: 'put',
    data
  })
}
// 查询用户放号通知订阅记录
export function getSubscriptionsApi(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/user-doctor-subscriptions`,
    method: 'get',
    params:data 
  })
}
// 添加用户放号通知订阅
export function addSubscriptionsApi(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/user-doctor-subscriptions`,
    method: 'post',
    data
  })
}
// 取消用户放号通知订阅
export function delSubscriptionsApi(id) {
  return axios.service({
    url: `/apis/v1/tenant/customer/user-doctor-subscriptions/${id}`,
    method: 'put',
  })
}
// 查询医生是否订阅
export function isSubscriptionsApi(doctorId) {
  return axios.service({
    url: `/apis/v1/tenant/customer/user-doctor-subscriptions/check-user-doctor-subscription/${doctorId}`,
    method: 'get',
  })
}